export default "__VITE_ASSET__BL1we3ap__";